<template>
  <div>
    <steps direction="vertical" :active="activeIndex" active-color="#439BFF">
      <step v-for="(item, i) in list" :key="i">
        <van-row>
          <van-col span="18" @click="companyDetailFn(item)">
            <h3>
              <span>{{queueType[item.type]}}</span>
              <span v-if="item.interview_time_str">-{{item.interview_time_str}}</span>
            </h3>
            <p>{{item.company_name}}丨{{item.job_name}}</p>
          </van-col>
          <van-col
            span="6"
            :class="'tr '  + (parseInt(item.type) === 0 && parseInt(item.state) < 1 ? ' can-cancel': '')"
          >
            <van-button
              size="small"
              type="info"
              plain
              @click="dealFn(item)"
            >{{queueState[(newState[item.invitation] !== undefined ? newState[item.invitation]: item.state) + '-' + item.type]}}</van-button>
          </van-col>
        </van-row>
      </step>
    </steps>

    <action-sheet
      v-model="showAction"
      :actions="actionsList"
      @select="onSelectFn"
      cancel-text="取消"
    />
  </div>
</template>

<script>
import { Step, Steps, ActionSheet } from "vant";
import { mapState } from "vuex";

export default {
  name: "invitation",
  components: {
    Step,
    Steps,
    ActionSheet
  },
  computed: {
    ...mapState({
      route: state => state.route,
      sign: state => state.sign,
      myApplyObj: state => state.myApplyObj,
      queueState: state => state.queueState,
      queueType: state => state.queueType,
      user_name: state => state.user_name,
    })
  },
  props: {
    list: {
      type: Array
    }
  },
  data() {
    return {
      activeIndex: 0,
      showAction: false,
      actionsList: [
        { name: "接受邀约", state: 1 },
        { name: "拒绝邀约", state: 2 }
      ],
      currentItem: {},
      newState: {}
    };
  },
  mounted() {
    this.initActive();
  },
  methods: {
    initActive() {
      let that = this;
      const { list } = that;

      let activeIndex = list.length;

      let item;
      for (let index = 0; index < list.length; index++) {
        item = list[index];
        if (
          item.over &&
          parseInt(item.state) === 0 &&
          parseInt(item.type) === 0
        ) {
          activeIndex = index;
          break;
        }
      }

      that.activeIndex = activeIndex;
    },
    dealFn(item) {
      const { type, state } = item;

      if (parseInt(type) === 0) {
        // 企业邀约
        if (parseInt(state) === 0) {
          this.currentItem = item;
          this.showAction = true;
        }
      } else {
        // 自己申请, 等待企业处理
        // 进入公司详情，取消申请
        this.companyDetailFn(item)
      }
    },
    onSelectFn(item) {
      const { state } = item;
      this.dealInvitation(state);
      this.showAction = false;
    },
    dealInvitation(state) {
      const { sign, currentItem, user_name } = this;

      const { invitation_apply_id, video_erp_register_id, video_jobfair_id } = currentItem;

      let that = this;

      const params = {
        invitation_apply_id,
        state,
        sign
      };

      that.$toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true
      });

      return new Promise(resolve => {
        that.$util.post("kzp_video_jobfair", "accept", params).then(res => {
          const { msg, code } = res;

          that.$toast.clear();

          if (code === 1) {
            // 通知pc  处理结果
            that.$store.commit("update_single_state", {
              key: "websocket_send_data",
              data: {
                flag: "notice",
                receiver_uid: video_erp_register_id,
                business_txt: user_name + (state === 1 ? '同意': '拒绝') + '了你的邀约',
                business_type: "处理邀约",
                business_id: invitation_apply_id,
                group_id: video_jobfair_id
              }
            });

            that.newState[invitation_apply_id] = state;
            that.initActive();

            // 刷新列表
            that.$emit("refresh", { state });
          } else {
            // 提示错误
            that.$notify({
              message: msg || "操作失败,请稍后再试!",
              type: "danger"
            });
          }
          resolve(res);
        });
      });
    },
    companyDetailFn(item){
      const { company_id, video_erp_register_id, video_jobfair_id } = item;

      this.$router.push({
        path:
          "/sub/company-detail?company_id=" +
          company_id +
          "&video_erp_register_id=" +
          video_erp_register_id +
          "&video_jobfair_id=" +
          video_jobfair_id
      });
    }
  },
  watch: {
    list: {
      handler(val, oldVal) {
        if (val > oldVal) {
          this.initActive();
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="">
</style>
